







































import { Component, Vue, Prop } from 'vue-property-decorator';

import * as STdata from '../data/data.json'

@Component
export default class AppNavigation extends Vue {
	@Prop({ required: true }) maxStatements!: any

	statements: any = (<any>STdata).default.statements

	navigateToWithTracking(statementId: number, track: 'start' | 'result') {
		if (track === 'start') {
			_paq.push(['trackEvent', 'userEvent', 'backToStart'])
		} else if (track === 'result') {
			_paq.push(['trackEvent', 'userEvent', 'backToResult'])
		}
		
		(<any>this.$parent).goToStatement(statementId)
	}

	hideNextButton(): boolean {
		if (this.$store.getters.currentStatementId === this.maxStatements) {
			return true
		} else if (this.$store.getters.choices[this.$store.getters.currentStatementId] === undefined) {
			return true
		}
		
		return false
	}
}
